class FormCalculator {
  constructor(el) {
    this.el = el;
    this.textBlockEl = document.querySelector('[data-text-block]');
    this.formBtnEl = this.el.querySelector('[data-form-btn]');
    this.formStepsContentEl = this.el.querySelectorAll('.fieldset-cf7mls');
    this.formBtnNavigateEl = this.el.querySelectorAll('.action-button');
    this.formStepsContainerEl = this.el.querySelector('[data-form-steps]');
    this.formStepsEl = this.el.querySelectorAll('[data-step]');
    this.savingsEl = this.el.querySelector('[data-calculator-savings]');
    this.savingTitleEl = this.savingsEl.querySelector('[data-savings-type]');
    this.savingEstimationEl = this.savingsEl.querySelector(
      '[data-savings-estimation]'
    );
    this.benefitsEl = this.el.querySelector('[data-calculator-benefits]');
    this.formEl = this.el.querySelector('form');
    this.currentStep = 0;
    this.init();
  }

  init() {
    this.navigate();
    this.checkFormSubmission();
    this.handleSavings();
  }

  showHideItemsFromView() {
    if (this.currentStep == 0) {
      this.textBlockEl.classList.remove('hidden');
      this.formBtnEl.classList.remove('hidden');
      this.formStepsContainerEl.classList.add('hidden');
      this.savingsEl.classList.add('hidden');
      if (this.benefitsEl) {
        this.benefitsEl.classList.add('hidden');
      }
      this.el.classList.remove('form-calculator--last-step');
    } else if (this.currentStep == 3) {
      this.el.classList.add('form-calculator--last-step');
      this.savingsEl.classList.remove('hidden');
      if (this.benefitsEl) {
        this.benefitsEl.classList.remove('hidden');
      }
    } else {
      this.textBlockEl.classList.add('hidden');
      this.formBtnEl.classList.add('hidden');
      this.formStepsContainerEl.classList.remove('hidden');
      this.el.classList.remove('form-calculator--last-step');
      this.savingsEl.classList.add('hidden');
      if (this.benefitsEl) {
        this.benefitsEl.classList.add('hidden');
      }
    }
  }

  handleSteps() {
    if (!this.formStepsEl) {
      return;
    }

    this.formStepsEl.forEach((step) => {
      if (step.dataset.step === this.currentStep) {
        step.classList.remove('complete');
        step.classList.add('active');
      } else if (step.dataset.step < this.currentStep) {
        step.classList.add('complete');
        step.classList.remove('active');
      } else {
        step.classList.remove('active');
      }
    });
  }

  navigate() {
    if (!this.formBtnNavigateEl) {
      return;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.target.classList.contains('cf7mls_current_fs')
        ) {
          this.formStepsContentEl.forEach((step) => {
            const currentStep = step.dataset.cf7mlsOrder;
            if (
              step.classList.contains('cf7mls_current_fs') &&
              currentStep !== 0
            ) {
              this.currentStep = step.dataset.cf7mlsOrder;
              this.showHideItemsFromView();
              this.handleSteps();
              this.scrollToTop();
            }
          });
        }
      });
    });

    this.formStepsContentEl.forEach((step) => {
      observer.observe(step, { attributes: true, attributeFilter: ['class'] });
    });
  }

  scrollToTop() {
    window.scrollTo({
      top: this.el.offsetTop,
      behavior: 'smooth',
    });
  }

  checkFormSubmission() {
    if (!this.formEl) {
      return;
    }

    this.formEl.addEventListener(
      'wpcf7mailsent',
      (event) => {
        this.currentStep = 0;
        this.showHideItemsFromView();
        this.handleSteps();
        this.handleFormDataHubspot(event);
      },
      false
    );
  }

  handleFormDataHubspot(event) {
    const formData = new FormData(event.target);
    formData.append('action', 'send_formdata_to_hubspot');

    fetch(`${window.location.origin}/wp-admin/admin-ajax.php`, {
      method: 'POST',
      credentials: 'same-origin',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleSavings() {
    if (!this.formEl) {
      return;
    }

    this.formEl.addEventListener('change', () => {
      const coverageHoursField = this.el.querySelector(
        '[name="coverage-hours"]'
      );
      const skillLevelField = this.el.querySelector('[name="skill-level"]');
      const supportTypeField = this.el.querySelector(
        '[name="support-type"]:checked'
      );
      const supportLanguageField = this.el.querySelector(
        '[name="support-language"]'
      );

      let coverageHours = '';
      let skillLevel = '';
      let supportType = '';
      let supportLanguage = '';

      if (coverageHoursField) {
        coverageHours = coverageHoursField.value;
      }
      if (skillLevelField) {
        skillLevel = skillLevelField.value;
      }

      if (supportTypeField) {
        supportType = supportTypeField.value;
      }

      if (supportLanguageField) {
        supportLanguage = supportLanguageField.value;
      }

      if (
        coverageHours === '24x7x365' ||
        skillLevel === '1-3rd Line' ||
        supportType === 'Onsite' ||
        supportType === 'Blended support' ||
        supportLanguage === 'UK + Other'
      ) {
        this.savingTitleEl.innerHTML = '5 - 15%';
        this.savingEstimationEl.innerHTML = 'Between 14 - 17 months';
      } else {
        this.savingTitleEl.innerHTML = '10 - 20%';
        this.savingEstimationEl.innerHTML = 'Between 17 - 19 months';
      }
    });
  }
}

export default FormCalculator;
